// Supervisory review section questionnaire constants
export enum SupervisoryReviewQuestionnaireItem {
  SUPERVISORY_REVIEW_ID_BADGE = 'supervisory-review/supervisory-review/id-badge',
  SUPERVISORY_REVIEW_HONORING_RIGHTS = 'supervisory-review/supervisory-review/honoring-rights',
  SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL = 'supervisory-review/supervisory-review/emergency-protocol',
  SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS = 'supervisory-review/supervisory-review/hygiene-precautions',
  SUPERVISORY_REVIEW_REPORTING_CHANGES = 'supervisory-review/supervisory-review/reporting-changes',
  SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT = 'supervisory-review/supervisory-review/grievance-complaint',
  SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER = 'supervisory-review/supervisory-review/poc-doc-reviewed-with-caregiver',
  SUPERVISORY_REVIEW_PPE_ACCESS = 'supervisory-review/supervisory-review/ppe-access',
  SUPERVISORY_REVIEW_SUPERVISION_OBSERVED = 'supervisory-review/supervisory-review/supervision-observed',
  SUPERVISORY_REVIEW_COMMENTS = 'supervisory-review/supervisory-review/comments',
  SUPERVISORY_REVIEW_TASK_OBSERVED = 'supervisory-review/supervisory-review/task-observed',
  SUPERVISORY_REVIEW_PATIENT_STATUS = 'supervisory-review/supervisory-review/patient-status',
  SUPERVISORY_REVIEW_EDUCATION_CAREGIVER_EDUCATION_TOPIC = 'supervisory-review/education/caregiver-education-topic',
  SUPERVISORY_REVIEW_EDUCATION_EDUCATION_PROVIDED = 'supervisory-review/education/education-provided'
}

// Export individual constants for use in other files
export const SUPERVISORY_REVIEW_ID_BADGE =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE
export const SUPERVISORY_REVIEW_HONORING_RIGHTS =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS
export const SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL
export const SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS
export const SUPERVISORY_REVIEW_REPORTING_CHANGES =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES
export const SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT
export const SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER
export const SUPERVISORY_REVIEW_PPE_ACCESS =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS
export const SUPERVISORY_REVIEW_SUPERVISION_OBSERVED =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED
export const SUPERVISORY_REVIEW_COMMENTS =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS
export const SUPERVISORY_REVIEW_TASK_OBSERVED =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_TASK_OBSERVED
export const SUPERVISORY_REVIEW_PATIENT_STATUS =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PATIENT_STATUS
export const SUPERVISORY_REVIEW_EDUCATION_TOPIC =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_CAREGIVER_EDUCATION_TOPIC
export const SUPERVISORY_REVIEW_EDUCATION_PROVIDED =
  SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_EDUCATION_PROVIDED
